export const ANALYTICS_TYPES = {
  EXO_LOAD_ERROR: 'prodex.exo.load.result.error',
  EXO_TOOL_INTERNAL_ERROR_TY_AGAIN:
    'prodex.exo.tool_internal_error.try_again.clicked',
  EXO_NAVIGATE_RESULT_404: 'prodex.exo.navigation_request.result.404',
  EXO_NAVIGATE_RESULT_404_GO_HOME: 'prodex.exo.404.go_home.clicked',
  DEEP_LINK_CLICK: 'prodex.deep_link.click',
  ANNOUNCMENT_BANNER_VIEW: 'prodex.announcement_banner.view',
  ANNOUNCMENT_BANNER_DISMISS: 'prodex.announcement_banner.dismiss',
  REGION_PICKER_OPEN: 'prodex.top_navigation.region_picker.open',
};
